import { reusableStyles } from 'ui-blocks/ReusableStyles';
import { colorPalette } from 'ui-blocks/ColorPalette';

export const navbarStyles = {
	container: {
		...reusableStyles.flexRow,
		justifyContent: 'space-between',
		paddingX: { xs: '24px', tabletMid: '38px' },
		paddingY: { xs: '8px', tabletMid: '19px' },
		maxHeight: { xs: '56px', tabletMid: '72px' },
		backgroundColor: colorPalette.dark45,
	},
	buttonStyles: {
		width: '150px',
		color: 'colors.light3',
		height: '40px',
		paddingX: '16px',
		border: `1px solid ${colorPalette.light3}`,
		borderRadius: '8px',
		'&:hover': {
			backgroundColor: 'colors.buttonTypeA_hover',
		},
	},
};
